export enum DialogButton {
    Ok = 0,
    Cancel = 1,
    OkCancel = 2,
    None = 3
}
